import { useApolloClient } from "@apollo/client"
import { useFormik } from "formik"
import { toBase64, removeExtension } from "../../../../common/FileUtilities"
import { uploadFormValidationSchema } from "./validationSchema"

interface UseUploadFormValidationProps {
    onValidSubmit: () => void
}
export function useUploadFormValidation({ onValidSubmit }: UseUploadFormValidationProps) {
    const client = useApolloClient()

    const formik = useFormik({
        // sets initial values to schema.default values
        initialValues: uploadFormValidationSchema(client).cast({}),
        onSubmit: values => {
            // onSubmit hook is only called when errors is empty
            onValidSubmit()
        },
        validationSchema: uploadFormValidationSchema(client),
        validateOnMount: true,
        validateOnBlur: false,
        validateOnChange: true
    })

    const audioFileHandleChange = async (file: File) => {
        if (formik.values.name === "") formik.setFieldValue("name", removeExtension(file.name))
        formik.setFieldValue("audioFile", await toBase64(file))
    }

    return {
        ...formik,
        audioFileHandleChange
    }
}
